import { message } from 'ant-design-vue';
import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import api from '@/api/user';
import _ from 'lodash';

@Module({ namespaced: true })
export default class extends VuexModule {
  token = ''

  userInfo: any = {}

  userMenus: any = []

  userPerms: any = []

  @Action
  async getCurrentUserInfo(params: any) {
    // 当前登录用户信息
    const res: any = await api.getUser(params);
    // console.log(res)
    if (res && res.Data) {
      this.context.commit('setUserInfo', res.Data.admin_user);
    }
    // 当前登录用户菜单
    const res2: any = await api.menus(params);
    // console.log(res2)
    if (res2 && res2.Data) {
      this.context.commit('setMenus', JSON.parse(res2.Data));
    }
    // 当前登录用户权限
    const res1: any = await api.perms(params);
    // console.log(res1)
    if (res1 && res1.Data) {
      this.context.commit('setPerms', res1.Data);
    }
  }

  @Mutation
  setPerms(params: any) {
    this.userPerms = params;
  }

  @Mutation
  setMenus(params: any) {
    this.userMenus = params;
  }

  @Action
  async logincaptcha(params: any) {
    return api.logincaptcha(params);
  }

  @Action
  async getUser(params: any) {
    return api.getUser(params);
  }

  @Action
  async saveInfo(params: any) {
    return api.saveInfo(params);
  }

  @Action
  async changePwd(params: any) {
    return api.changePwd(params);
  }

  @Action
  async logout(params: any) {
    const res: any = await api.logout(params);
    if (res && res.Message === 'success') {
      this.context.commit('removeToken');
      window.localStorage.removeItem('token');
    }
    return res;
  }

  @Action
  async login(params: any) {
    const res: any = await api.login(params);
    // console.log(res)
    if (res && res.Message === 'success') {
      // console.log('login success')
      // console.log(res.Data.token)

      window.localStorage.setItem('token', res.Data.token);
      this.context.commit('saveToken', res.Data.token);
      // this.context.commit('setUserInfo', res.data)
    }
    return res;
  }

  @Action
  async refreshToken(params: any) {
    return api.refreshToken(params);
  }

  @Action
  async getCaptcha(params: any) {
    return api.getcaptcha(params);
  }

  @Action
  async resetPwd(params: any) {
    return api.resetpwd(params);
  }

  @Action
  async getSug(params: any) {
    return api.sug(params);
  }

  @Action
  async perms(params: any) {
    return api.perms(params);
  }

  @Action
  async menus(params: any) {
    return api.menus(params);
  }

  @Action
  async saveStateInfo(params: any) {
    this.context.commit('setUserInfo', { ...params });
  }

  @Action
  async balance(params: any) {
    return api.balance(params);
  }

  @Action
  async withdraw(params: any) {
    return api.withdraw(params);
  }

  @Mutation
  saveToken(token: string) {
    this.token = token;
  }

  @Mutation
  removeToken() {
    this.token = '';
    window.localStorage.removeItem('token');
  }

  @Mutation
  setUserInfo(info: any) {
    this.userInfo = info;
  }
}
